import DefaultCRUD from '../utils'
const resource = `/contact-wire`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
